import { Box, Dialog, DialogContent, Typography } from '@material-ui/core'
import { Button } from "@paro.io/base-ui";
import React from 'react'
import styled from 'styled-components'

const ButtonContainer = styled(Box)`
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
`

interface ApplicationInfoModalProps {
  handleChange: React.Dispatch<React.SetStateAction<boolean | null>>
  isCurrentResident: boolean | null
}

const ApplicationInfoModal = ({ handleChange, isCurrentResident }: ApplicationInfoModalProps) => {
  return (
    <Dialog open={isCurrentResident === false} onClose={() => handleChange(null)}>
      <DialogContent style={{ padding: 50 }}>
        <Typography variant="h5" style={{ maxWidth: 350 }}>
          Thank you for your interest, at this time we are only accepting experts based in the United States.
        </Typography>
        <ButtonContainer>         
          <Button onClick={()=>window.location.href="https://paro.io/"} color="primary" label='Paro.io' />
        </ButtonContainer>
      </DialogContent>
    </Dialog>
  )
}

export default ApplicationInfoModal
